import { useState } from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, ButtonTypeEnum, Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./HowPricingWorksLink.module.scss";
import { HowPricingWorksDialog } from "@/components/shared";

export const HowPricingWorksLink = ({ className }: PlatformComponentProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "HowPricingWorksLink");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={clsx(block, className)}>
      <HowPricingWorksDialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <Button
          buttonType={ButtonTypeEnum.Link}
          onClick={() => setIsModalOpen(true)}
          className={cn("link")}
        >
          <span>{t("core-flights.howPricingWorks.link")}</span>
          <Icon iconName={IconNameEnum.rightArrow} />
        </Button>
      </HowPricingWorksDialog>
    </div>
  );
};
